/**
 * Created by Sasha on 7/25/2018.
 */
import moment from 'moment';
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable , BehaviorSubject} from 'rxjs';
import { AppConfig } from '../../app.config';
@Injectable()
export class PictureService  {
  pictures: any[];
  onPictureChanged: BehaviorSubject<any> = new BehaviorSubject({});
  constructor (private http: HttpClient, private api: AppConfig) {

  }
  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
  {

    return new Promise<void>((resolve, reject) => {

      Promise.all([
        this.getPictures()
      ]).then(
        () => {
          resolve();
        },
        reject
      );
    });
  }

  getPictures () {
    return new Promise((resolve, reject) => {
      this.http.get(this.api.baseUrl + '/picture/pictures'  , this.api.jsonTokenHeaders)
        .subscribe((response: any) => {
          this.pictures = response;
          this.onPictureChanged.next(this.pictures);
          resolve(response);
        }, reject);
    });

  }

  getPictureById(id) {
    return this.http.get(this.api.baseUrl + '/picture/picture?id=' + id , this.api.jsonTokenHeaders);
  }

  deletePicture(id) {
    return this.http.delete(this.api.baseUrl + '/picture/deletePicture?id=' + id , this.api.jsonTokenHeaders);
  }

  addPicture(data) {
    const formData: FormData = new FormData();
    formData.append('file', data);
    return this.http.post(this.api.baseUrl + '/picture/addPicture' , formData , this.api.formDataHeaders);
  }
}
